// extracted by mini-css-extract-plugin
module.exports = {"icon":"ContactUs_icon__2g6dw","textSize":"ContactUs_textSize__g3Vk0","fontSize":"ContactUs_fontSize__wDZNG"};